import { FIELD_CONSTRAINTS, LOGIC_GATE } from '../../../utility/constants'

export const constraintValidationWithOperation = (
  fieldsProcessDataValue,
  fieldsConditionalValue,
  operation
) => {
  switch (operation) {
    case FIELD_CONSTRAINTS.EQUAL:
    case 'equal': // to support backward compatibility - can be removed after some time.
      return fieldsProcessDataValue == fieldsConditionalValue // loose equality to check for string, number and all other data type
    case FIELD_CONSTRAINTS.GT:
      return Number(fieldsProcessDataValue) > Number(fieldsConditionalValue)
    case FIELD_CONSTRAINTS.GTE:
      return Number(fieldsProcessDataValue) >= Number(fieldsConditionalValue)
    case FIELD_CONSTRAINTS.LT:
      return Number(fieldsProcessDataValue) < Number(fieldsConditionalValue)
    case FIELD_CONSTRAINTS.LTE:
      return Number(fieldsProcessDataValue) <= Number(fieldsConditionalValue)
    case FIELD_CONSTRAINTS.INT:
      return Number.isInteger(fieldsProcessDataValue)
    case FIELD_CONSTRAINTS.POSITIVE_INT:
      return Number.isInteger(fieldsProcessDataValue) && Number(fieldsProcessDataValue) >= 0
    case FIELD_CONSTRAINTS.WHOLE_NUM:
      return Number(fieldsProcessDataValue) >= 0
    case FIELD_CONSTRAINTS.POSITIVE:
      return Number(fieldsProcessDataValue) >= 0

    default:
      return false
  }
}

export const applyLogicGate = (values, gateName) => {
  if (values.length === 0) {
    return false
  }

  switch (gateName) {
    case LOGIC_GATE.AND:
      return values.every((value) => value === true) // AND gate: all values must be true
    case LOGIC_GATE.OR:
      return values.some((value) => value === true) // OR gate: any value being true returns true
    case LOGIC_GATE.NOR:
      return !values.some((value) => value === true) // NOR gate: returns true only if all values are false
    default:
      throw new Error('Invalid gate name. Valid gates are AND, OR, and NOR.')
  }
}
